import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  AppBar,
  Badge,
  Box,
  IconButton,
  makeStyles,
  Toolbar,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/NotificationsOutlined";
import InputIcon from "@material-ui/icons/Input";
import logo from "src/assets/images/conexopluswhite.png";
import { useSelector, useDispatch } from "react-redux";
import { trocar_empresa } from "src/store/actions/usuario";
import * as types from "src/store/types/usuario";
import { Loading, SelectBox } from "src/components";

const useStyles = makeStyles((theme) => ({
  togglerSidebar: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
  },
  headerIcons: {
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
}));

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const [notifications] = useState([]);

  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { empresa_atual, empresas, loading } = useSelector(
    (state) => state.usuario
  );

  const signOut = () => {
    localStorage.removeItem("token");
    dispatch([
      {
        type: types.USUARIO_SET_USER,
        payload: {},
      },
      {
        type: types.USUARIO_SET_EMPRESAS,
        payload: [],
      },
      {
        type: types.USUARIO_SET_EMPRESA_ATUAL,
        payload: {},
      },
      { type: types.USUARIO_SET_SELECT_EMPRESA, payload: false },
    ]);
    navigate("/");
  };

  const handleChangeEmpresa = async (empresa_id) => {
    await trocar_empresa(empresa_id);
    window.location.reload();
  };

  return (
    <AppBar elevation={0} {...rest}>
      <Loading loading={loading} />
      <Toolbar>
        <RouterLink to="/app">
          <img 
            src={logo}
            style={{width: 150, height: 55}}
          />
        </RouterLink>
        <Box flexGrow="1" />
        {empresas.length > 1 && (
          <SelectBox
            identifyBy="id"
            identifyName="nome"
            initialValue={empresa_atual}
            onChange={handleChangeEmpresa}
            options={empresas}
          >
            {empresas.map((empresa) => (
              <li key={empresa.id} data-value={empresa.id}>
                {empresa.nome}
              </li>
            ))}
          </SelectBox>
        )}
        <Box className={classes.headerIcons}>
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton onClick={signOut} color="inherit">
            <InputIcon />
          </IconButton>
        </Box>
        <Box className={classes.togglerSidebar}>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;
